// src/App.js
import React from 'react';
import TextCorrector from './TextCorrector';
import './App.css';

function App() {
  return (
    <div className="App">
      <TextCorrector />
    </div>
  );
}

export default App;
